export interface INavigationRoute {
  name: string
  displayName: string
  meta: { icon: string }
  children?: INavigationRoute[]
}

export default {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    {
      name: 'dashboard',
      displayName: 'menu.dashboard',
      meta: {
        icon: 'vuestic-iconset-dashboard',
      },
    },
    {
      name: 'users',
      displayName: 'Participantes',
      meta: {
        icon: 'people',
      },
    },
    {
      name: 'eventos',
      displayName: 'Eventos',
      meta: {
        icon: 'event',
      },
    },
    {
      name: 'vendas',
      displayName: 'Vendas',
      meta: {
        icon: 'shopping_cart',
      },
    },
    {
      name: 'produtos',
      displayName: 'Produtos',
      meta: {
        icon: 'inventory',
      },
      children: [
        {
          name: 'list-products',
          displayName: 'Lista Produtos',
        },
        {
          name: 'registration-product',
          displayName: 'Cadastros',
        },
      ],
    },
    {
      name: 'contasareceber',
      displayName: 'Meu Dinheiro',
      meta: {
        icon: 'money',
      },
      children: [
        {
          name: 'finance',
          displayName: 'Extrato',
        },
        {
          name: 'transfer',
          displayName: 'Transferência',
        },
      ],
    },
    // {
    //   name: 'eventos',
    //   displayName: 'Eventos',
    //   meta: {
    //     icon: 'group',
    //   },
    //   children: [
    //     {
    //       name: 'pricing-plans',
    //       displayName: 'Lista Eventos',
    //     },
    //     {
    //       name: 'registration-events',
    //       displayName: 'Cadastros',
    //     },
    //   ],
    // },
    // {
    //   name: 'projects',
    //   displayName: 'menu.projects',
    //   meta: {
    //     icon: 'folder_shared',
    //   },
    // },
    // {
    //   name: 'payments',
    //   displayName: 'menu.payments',
    //   meta: {
    //     icon: 'credit_card',
    //   },
    //   children: [
    //     {
    //       name: 'payment-methods',
    //       displayName: 'menu.payment-methods',
    //     },
    //     {
    //       name: 'pricing-plans',
    //       displayName: 'menu.pricing-plans',
    //     },
    //     {
    //       name: 'billing',
    //       displayName: 'menu.billing',
    //     },
    //   ],
    // },
    // {
    //   name: 'auth',
    //   displayName: 'menu.auth',
    //   meta: {
    //     icon: 'login',
    //   },
    //   children: [
    //     {
    //       name: 'login',
    //       displayName: 'menu.login',
    //     },
    //     {
    //       name: 'signup',
    //       displayName: 'menu.signup',
    //     },
    //     {
    //       name: 'recover-password',
    //       displayName: 'menu.recover-password',
    //     },
    //   ],
    // },

    // {
    //   name: 'faq',
    //   displayName: 'menu.faq',
    //   meta: {
    //     icon: 'quiz',
    //   },
    // },
    // {
    //   name: '404',
    //   displayName: 'menu.404',
    //   meta: {
    //     icon: 'vuestic-iconset-files',
    //   },
    // },
    // {
    //   name: 'preferences',
    //   displayName: 'menu.preferences',
    //   meta: {
    //     icon: 'manage_accounts',
    //   },
    // },
    // {
    //   name: 'settings',
    //   displayName: 'menu.settings',
    //   meta: {
    //     icon: 'settings',
    //   },
    // },
  ] as INavigationRoute[],
}
